export class Paginacao {
  page: number;
  pageSize: number;
  totalRows: number;

  constructor(obj?: any) {
    if (obj) {
      this.page = obj.page;
      this.pageSize = obj.pageSize;
      this.totalRows = obj.totalRows;
    } else {
      this.page = 1;
      this.pageSize = 10;
      this.totalRows = 0;
    }
  }
}
